import axiosConfig from '../../config/axiosConfig';

export const getSocketToken = () => {
  return axiosConfig
    .post('/web_socket_connection', {})
    .then(response => response.data)
    .catch(error => error.response.data)
    .catch(() => 'lost connection to the server');
};
